import styled from 'styled-components';

import { RedButton, BlueButton } from 'libs/ui';
import { ControlPanel } from '../styledComponents';

export const PaymentMeanButtons = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 30px;
  & > button {
    margin: 0 30px 0 0 !important;
    &:last-child {
      margin: 0 !important;
    }
  }
`;

export const ControlBlocks = styled.div`
  margin: 30px 0;
`;

export const StyledControlPanel = styled(ControlPanel)`
  padding: 20px;

  &.offline::before {
    content: '${(props) => props.$status}';
  }
`;

export const OpenGateButton = styled(BlueButton)`
  img {
    margin: 0 10px;
  }
  width: 160px;
  height: 30px;
  display: flex;
`;
export const CloseGateButton = styled(RedButton)`
  img {
    margin: 0 10px;
  }
  width: 160px;
  height: 30px;
  display: block;
  margin-top: 40px;
`;

export const ControlBlockHeader = styled.div`
  font-size: 15px;
  font-weight: normal;
  line-height: normal;
  /* opacity: 0.45; */
  color: #fff;
  margin: 0 0 5px;
`;
